import script from "./StatusView.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__